{
  "title": "Otherworldly Form (UA)",
  "source": "Unearthed Arcana 70 - Spells and Magic Tattoos",
  "levelAndSchool": "6th-level transmutation",
  "level": 6,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (an object engraved with a symbol of the Outer Planes, worth at least 500 gp)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Uttering an incantation, you draw on the magic of the Lower Planes or Upper Planes (your choice) to transform yourself. You gain the following benefits until the spell ends:",
    "You are immune to fire and poison damage (Lower Planes) or radiant and necrotic damage (Upper Planes).",
    "You are immune to the poisoned condition (Lower Planes) or the charmed condition (Upper Planes).",
    "Spectral wings appear on your back, giving you a flying speed of 40 feet.",
    "You have a +2 bonus to AC.",
    "All your weapon attacks are magical, and when you make a weapon attack, you can use your spellcasting ability modifier, instead of Strength or Dexterity, for the attack and damage rolls.",
    "You can attack twice, instead of once, when you take the Attack action on your turn. You ignore this benefit if you already have a feature, like Extra Attack, that gives you extra attacks"
  ],
  "spellLists": ["cleric", "sorcerer", "warlock", "wizard"]
}
